import React, {Component} from "react";

class NotFound extends Component {

    render() {
	
		document.title = global.config.pageTitles.notfound + 
					global.config.pageTitles.seperator +
					global.config.pageTitles.title;	
			
        return (
          	<div className="notfound">
			<div className="container sj-container">
			
				<div className="row align-items-center">
					<div className="col-lg-12 col-sm-12">
						<h1 className="font-weight-light">Page Not Found</h1>
						<p>
						Sorry, the page you were attempting to view may no longer exist. 
						Please check the URL for proper spelling and capitalization. 
						This could be due to a page you have bookmarked that has been removed. 
						The page you are looking for may be found by using the navigation above.
						</p>	
					</div>			        
			    </div>
			    
			</div>
			</div>
        );
        
    }

}

export default NotFound;